import React, { useState, useEffect } from "react";
import { doc, getFirestore, collection, getDocs, getDoc } from 'firebase/firestore';
import { sendNotification } from './functions/sendNotification';

export default function NotificationForm() {
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [users, setUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);

 useEffect(() => {
        const fetchData = async () => {
            try {
                const firestore = getFirestore();

                const usersCollection = collection(firestore, 'Users');

                // Get documents from the collection
                const snapshot = await getDocs(usersCollection);

                // Process the snapshot
                const fetchedData = snapshot.docs.map(doc => doc.data());

                setUsers(fetchedData);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchData(); // Call the function to fetch data
    }, []);

  const handleSend = async () => {
    if (!title.trim() || !content.trim() || selectedUsers.length === 0) {
      alert("Please fill in all fields and select at least one user.");
      return;
    }

    for (const userId of selectedUsers) {
      await sendNotification(userId, title, content, "/");
    }

    alert("Notifications sent!");
    setTitle("");
    setContent("");
    setSelectedUsers([]);
  };


  return (
    <div style={{ maxWidth: 400, margin: "20px auto", fontFamily: "Arial" }}>
      <h2>Send Notification</h2>

      <label>Title</label>
      <input
        type="text"
        value={title}
        onChange={e => setTitle(e.target.value)}
        style={{ width: "100%", marginBottom: 10, padding: 8 }}
      />

      <label>Content</label>
      <textarea
        value={content}
        onChange={e => setContent(e.target.value)}
        style={{ width: "100%", marginBottom: 10, padding: 8 }}
      />

      <label>Select Users</label>
      <select
        multiple
        value={selectedUsers}
        onChange={e =>
          setSelectedUsers(Array.from(e.target.selectedOptions, opt => opt.value))
        }
        style={{ width: "100%", marginBottom: 10, padding: 8 }}
      >
        {users.map(user => {
            if(user.subscriptions == null){return null;}
            return (
          <option key={user.Email} value={user.Email}>
            {user.Name}
          </option>
            )
        })}
      </select>

      <button
        onClick={handleSend}
        style={{
          width: "100%",
          padding: 10,
          backgroundColor: "#007bff",
          color: "#fff",
          border: "none",
          cursor: "pointer"
        }}
      >
        Send
      </button>
    </div>
  );
}
